import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AiChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
}

interface AiAssistantState {
  isOpen: boolean;
  messages: AiChatMessage[];
  isTyping: boolean;
  agentName: string;
  personaName: string;
  greetingMessage: string;
  closingMessage: string;
  
  // Actions
  toggleChat: () => void;
  openChat: () => void;
  closeChat: () => void;
  addMessage: (message: AiChatMessage) => void;
  setMessages: (messages: AiChatMessage[]) => void;
  setTyping: (isTyping: boolean) => void;
  clearHistory: () => void;
  setAgentInfo: (agentName: string, personaName: string, greetingMessage?: string, closingMessage?: string) => void;
}

export const useAiAssistantStore = create<AiAssistantState>()(
  persist(
    (set) => ({
      isOpen: false,
      messages: [],
      isTyping: false,
      agentName: '',
      personaName: '',
      greetingMessage: '',
      closingMessage: '',
      
      toggleChat: () => set((state) => ({ isOpen: !state.isOpen })),
      openChat: () => set({ isOpen: true }),
      closeChat: () => set({ isOpen: false }),
      addMessage: (message) => set((state) => ({ 
        messages: [...state.messages, message] 
      })),
      setMessages: (messages) => set({ messages }),
      setTyping: (isTyping) => set({ isTyping }),
      clearHistory: () => set({ messages: [] }),
      setAgentInfo: (agentName, personaName, greetingMessage, closingMessage) => set({ 
        agentName, 
        personaName,
        greetingMessage: greetingMessage || '',
        closingMessage: closingMessage || ''
      })
    }),
    {
      name: 'ring2all-ai-assistant', // unique name
      partialize: (state) => ({ messages: state.messages }) // only persist messages if we want local caching, but server holds truth
    }
  )
);
